import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Box,
    Typography,
    Button,
} from '@mui/material';

export default function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        fontSize: '120px',
                        fontWeight: 'bold',
                        color: 'primary.main',
                    }}
                >
                    404
                </Typography>
                <Typography variant="h5" sx={{ mb: 2 }}>
                    Page Not Found
                </Typography>
                <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', mb: 4 }}
                >
                    The page you're looking for doesn't exist or has been moved.
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate('/')}
                >
                    Go to Home
                </Button>
            </Box>
        </Container>
    );
}
